import React from 'react';
import { Button } from '@/components/ui/button';
import { ButtonProps } from '@/types';

export const StyledButton: React.FC<ButtonProps> = ({
  children,
  onClick,
  disabled = false,
  className = '',
  type = 'button',
}) => {
  return (
    <Button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`
        bg-teal
        text-lg
        font-bold
        transition-all duration-150
        !border-2 !border-yellow 
        active:scale-[0.98]
        hover:bg-teal/90
        

        text-yellow
        [text-shadow:1px_1.2px_0_#000]

        ${className}
      `}
    >
      {children}
    </Button>
  );
};
